import { createAssetReference } from './create'

export const assetReferences = {
  create: createAssetReference,
}
